const roleAccess = (userRole, requiredRoles) => {
    if (Array.isArray(requiredRoles)) {
      return requiredRoles.includes(userRole);
    }
    return userRole === requiredRoles;
  };
  
  export default roleAccess;